import { checkTowerVersion } from 'next/javascripts/modules/utils'

# 全局组件的初始化操作

$ ->
  Offline.on 'up', ->
    location.reload()

  # 时区初始化
  simple.tpl.tz = $('#member-timezone').val() || 'Asia/Shanghai'

  # 初始化所有的tooltip
  $(document).on 'mouseenter', '[data-tooltip]', (e) ->
    $('.simple-tooltip').remove()
    $target = $(@)
    content = $target.attr 'data-tooltip'
    return unless content
    tooltip = simple.tooltip
      el: $target
      content: content
      position: $target.attr('data-position') or 'auto'
    tooltip.show()
  .on 'mouseleave', '[data-tooltip]', (e) ->
    tooltip = $(@).data('simple-tooltip')
    if tooltip then tooltip.hide() else $('.simple-tooltip').remove()

  # 初始化group按钮交互
  $(document).on 'click', '.btn-group .btn-dropdown-toggle', (e) ->
    e.preventDefault()
    e.stopPropagation()

    btn = $(e.currentTarget)
    group = btn.closest('.btn-group').toggleClass('dropdown')
    doc = $(document)

    if group.is('.dropdown')
      doc.one 'click.btn-dropdown', (e) ->
        group.removeClass('dropdown')
    else
      doc.off('click.btn-dropdown')
  .on 'click.btn-dropdown', '.btn-group .btn-dropdown-menu', (e) -> removeDropDown(e)
  .on 'click.btn-dropdown', '.btn-group .btn-dropdown-menu .btn-new-todo', (e) -> removeDropDown(e)

  # 当表单提交成功，调用autosave的clear方法
  $(document).on 'ajax:success', (e)->
    el = $(e.target)
    el.data('autosave')?.clear()

  # 编辑器默认配置
  tower.editorConfig =
    defaultImage: "#{process.env.OSS_ASSETS_ENDPOINT}/icon-tower.png"
    pasteImage: 'inline'
    toolbar: ['emoji', 'bold', 'italic', 'underline', 'strikethrough', 'color', 'fontScale', '|',
        'ol', 'ul', 'blockquote', 'code', 'indent', 'outdent', 'alignment', '|',
        'link', 'image', 'attachment', 'hr', 'table'],
    params:
      is_html: 1
    upload:
      url: "/oss/teams/#{tower.team.guid}/attachments.json"
      params:
        conn_guid: $('#conn-guid').val()
        authenticity_token: $('meta[name=csrf-token]').attr('content')
      cloud: false
    maxImageWidth: 630
    tabIndent: false
    emoji:
      imagePath: 'https://s.tower.im/emoji/'
      images: [
        'lengtoo_7.gif'
        'lengtoo_10.gif'
        'lengtoo_11.gif'
        'lengtoo_15.gif'
        'lengtoo_18.gif'
        'lengtoo_20.gif'
        'lengtoo_24.gif'
        'lengtoo_26.gif'
        'lengtoo_29.gif'
        'lengtoo_31.gif'
        'smile.png'
        'smiley.png'
        'laughing.png'
        'blush.png'
        'heart_eyes.png'
        'smirk.png'
        'flushed.png'
        'grin.png'
        'wink.png'
        'kissing_closed_eyes.png'
        'stuck_out_tongue_winking_eye.png'
        'stuck_out_tongue.png'
        'sleeping.png'
        'worried.png'
        'expressionless.png'
        'sweat_smile.png'
        'cold_sweat.png'
        'joy.png'
        'sob.png'
        'angry.png'
        'mask.png'
        'scream.png'
        'sunglasses.png'
        'heart.png'
        'broken_heart.png'
        'star.png'
        'anger.png'
        'exclamation.png'
        'question.png'
        'zzz.png'
        'thumbsup.png'
        'thumbsdown.png'
        'ok_hand.png'
        'punch.png'
        'v.png'
        'clap.png'
        'muscle.png'
        'pray.png'
        'skull.png'
        'trollface.png'
      ]
    livemd:
      title: false
      bold: false
      italic: false
      image: false
      link: false
    allowedAttributes:
      a: ['href', 'target', 'data-mention']
      blockquote: ['data-reply']
      img: ['src', 'alt', 'width', 'height', 'data-non-image', 'data-image-size', 'data-image-name']
      font: ['color', 'font-size', 'size']
    codeLanguages: [
      { name: 'Bash', value: 'bash' }
      { name: 'C#', value: 'cs' }
      { name: 'C++', value: 'c++' }
      { name: 'CoffeeScript', value: 'coffeescript' }
      { name: 'CSS', value: 'css' }
      { name: 'Diff', value: 'diff' }
      { name: 'Erlang', value: 'erlang' }
      { name: 'Go', value: 'lisp' }
      { name: 'HTML,XML', value: 'html' }
      { name: 'Java', value: 'java' }
      { name: 'JavaScript', value: 'js' }
      { name: 'JSON', value: 'json' }
      { name: 'Less', value: 'less' }
      { name: 'Lisp', value: 'lisp' }
      { name: 'Markdown', value: 'markdown' }
      { name: 'Objective C', value: 'oc' }
      { name: 'Perl', value: 'parl' }
      { name: 'PHP', value: 'php' }
      { name: 'Python', value: 'python' }
      { name: 'Ruby', value: 'ruby' }
      { name: 'Scss', value: 'scss' }
      { name: 'SQL', value: 'sql' }
      { name: 'Swift', value: 'swift' }
    ]

  # 新手引导初始化
  tower.unusedBubbles = (() ->
    bubbles = ($('#unused-bubbles').val() || "").split(',')
    $.map bubbles, (val, idx) ->
      return val * 1
  )()

  # init simple stack
  tower.stack = simple.stack
    el: '.workspace'
    title: '{{ name }} - Tower'
    slowTime: 0

  tower.stack.on 'pageload', (e, $page, page, xhr) ->
    version = xhr.getResponseHeader('X-TWR-VERSION') if xhr
    checkTowerVersion(version) if version
    $page.closest('.simple-stack')
      .toggleClass 'simple-stack-fluid', $page.is('[data-stack-fluid]')
    $page.closest('.simple-stack')
      .toggleClass 'simple-stack-fullscreen', $page.is('[data-stack-fullscreen]')
    $page.closest('.simple-stack')
      .toggleClass 'simple-stack-filter-editor', $page.is('[data-stack-filter-editor]')

    tower.adjustReadableTime()
    tower.adjustReadableDate()
    tower.initPermission($page)

    $checkbox = $('.todo-form input[name="todo-done"]')
    $checkbox.each () ->
      simple.checkbox
        el: this

    # 知识库以外的页面隐藏侧边栏
    nav = document.querySelector('tr-repository-nav')
    nav.remove() if nav and !document.querySelector('#tpl-tr-repository-nav')

  # 知识库以外的页面隐藏侧边栏
  tower.stack.on 'pagebeforeload', (e, page) ->
    nav = document.querySelector('tr-repository-nav')
    nav.remove() if nav and !page.url.match(/repositories|repository/)

  tower.stack.on 'pageunload', (e, $page, page) ->
    $('[data-tooltip]').each () ->
      $(@).data('simple-tooltip')?.destroy()

    simple.popover.destroyAll()
    simple.dialog.removeAll()
    $('tr-dialog').each () ->
      @close()

    # destroy all simple select
    $(".simple-select").each () ->
      $(@).data('select').destroy()

    $('.simple-subtasks').each () ->
      $(@).data('subtasks').destroy()

    tower.highlight('clear')

    $(document).trigger("mousedown.notipop")

    # destroy all filedrop instance
    $('.simple-filedrop').each () ->
      $(@).data('filedrop').destroy()

    tower.scrollLoad(false)

    # remove the current active nav
    # the nav will be activated in pajxload event in different pages
    $('.header .nav li.active').removeClass('active')

    # make sure group button is collapsed
    $('.btn-group.dropdown').removeClass('dropdown')

    tower.stack.lastPageUrl = if page then page.url else tower.stack.lastPageUrl

    e.result

  tower.adjustReadableTime()
  tower.adjustReadableDate()
  tower.initPermission()
  tower.searchBar?()
  tower.newDocsDialog?()

  window.PAGE_BUBBLE_GUIDES = []

  # remove page loading mask
  $('#page-loading-mask').remove()


# juqery ui hack
if $.ui && $.ui.sortable
  # jquery ui sortable beforestart event
  sortableMouseStart = $.ui.sortable.prototype._mouseStart
  $.ui.sortable.prototype._mouseStart = (event, overrideHandle, noActivation) ->
    @._trigger("beforestart", event, @._uiHash())
    sortableMouseStart.apply(@, [event, overrideHandle, noActivation])

  # fix jquery ui scrollParent bug
  scrollParent = $.fn.scrollParent
  $.fn.scrollParent = () ->
    parent = scrollParent.apply(@, arguments)
    if parent.is("html") then $(document) else parent

if $.ui && $.ui.draggable
  draggableMouseStart = $.ui.draggable.prototype._mouseStart
  $.ui.draggable.prototype._mouseStart = (event, overrideHandle, noActivation) ->
    @._trigger("beforestart", event, @._uiHash())
    draggableMouseStart.apply(@, [event, overrideHandle, noActivation])

removeDropDown = (e) ->
  e.stopPropagation()
  $(e.currentTarget).closest('.btn-group').removeClass('dropdown')
